import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { Select2Data } from "../../../utils/api";
import Select from "react-select";
library.add(fas);

const EditPullProductVender = (props) => {
  const id = props.show?.id;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const d = new FormData();
      d.append("product_id", data?.product_id?.value);
      const response = await postData(`/pull-product/pull-vender-product`, d);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const Select3Data = async (data, name, other = false) => {
    const result = data.map((item) => ({
      value: item?.id,
      label: `${item?.name} - ${item?.product_detail?.brand?.name}`,
      name: name,

      // full product data
      data: item,
    }));

    if (other) {
      result.push({
        value: "0",
        label: "Other",
        name: name,
      });
    }

    return result;
  };

  const [products, setProducts] = useState([]);
  const GetAllVenderProduct = async () => {
    const response = await getData("/all-pull-products");

    if (response?.success) {
      setProducts(await Select3Data(response?.data, "category_id"));
    }
  };
  useEffect(() => {
    GetAllVenderProduct();
  }, []);
  const selectedProduct = watch("product_id");
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Pull Product of Vender
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              {/* <Col md={6}> */}
              <div className="main-form-section mb-6">
                <Row className="justify-content-center">
                  <Col md={12}>
                    <Form.Group className="w-100">
                      <div className="text-center">
                        <Form.Label>Pull Product</Form.Label>
                      </div>

                      <InputGroup className="w-100">
                        <Controller
                          name="product_id"
                          {...register("product_id", {
                            required: "Select Product",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              className="w-100"
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: "100%",
                                }),
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  width: "100%",
                                  minHeight: "45px",
                                  borderColor: errors.product_id
                                    ? "red"
                                    : baseStyles.borderColor,
                                }),
                              }}
                              {...field}
                              options={products}
                            />
                          )}
                        />
                      </InputGroup>

                      {errors.product_id && (
                        <span className="text-danger">
                          {errors.product_id.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>
                  {selectedProduct?.data && (
                    <Col md={12} className="mt-3">
                      <div className="border p-3 rounded">
                        <h5>Selected Product Details</h5>

                        <p>
                          <strong>Product Name:</strong>{" "}
                          {selectedProduct?.data?.name}
                        </p>

                        <p>
                          <strong>Brand:</strong>{" "}
                          {selectedProduct?.data?.product_detail?.brand?.name}
                        </p>

                        {/* <p>
                          <strong>Price:</strong> {selectedProduct?.data?.price}
                        </p> */}

                        <p>
                          <strong>Description:</strong>{" "}
                          {selectedProduct?.data?.short_description}
                        </p>

                        {selectedProduct?.data?.image1 && (
                          <img
                            src={IMG_URL + selectedProduct?.data?.image1}
                            alt="product"
                            width={120}
                          />
                        )}
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
              {/* </Col> */}

              <div className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditPullProductVender;
